export default "__VITE_ASSET__676ed874__"